<mat-form-field
  appearance="outline"
  class="mat-input-custom"
  [ngClass]="
    visuallyDisabledFields['chassis_number'] ? 'visually-disabled' : ''
  "
>
  <mat-label>Chassis Number</mat-label>
  <input
    matInput
    formControlName="chassis_number"
    class="text-uppercase"
    id-automation="chassis_number"
    minlength="6"
    maxlength="30"
    appNoMaskedValue
    (input)="onFieldChange()"
    [readonly]="visuallyDisabledFields['chassis_number']"
  />
  <mat-error
    *ngIf="chassisForm.controls['chassis_number']?.hasError('required')"
  >
    This is a required field.
  </mat-error>

  <mat-error
    *ngIf="chassisForm.controls['chassis_number']?.hasError('maxlength')"
  >
    Exceeded max limit
  </mat-error>
  <mat-error
    *ngIf="chassisForm.controls['chassis_number']?.hasError('minlength')"
  >
    Cannot be less than 6 Characters
  </mat-error>
  <mat-error
    *ngIf="chassisForm.controls['chassis_number']?.hasError('maxlength')"
  >
    Cannot be more than 30 Characters
  </mat-error>
  <mat-error *ngIf="chassisForm.get('chassis_number')?.hasError('invalidEngineNumber')">
    Please enter a valid chassis number
  </mat-error>
</mat-form-field>
